const d = new Date();
let year = d.getFullYear();

export default year;
